import React from 'react';
import { getPasswordStrength } from '../../utils/passwordUtils';

const PasswordStrength = ({ password }) => {
  const strength = getPasswordStrength(password);
  if (!password) return null;

  return (
    <div className="auth-password-strength">
      <div className="auth-password-strength-bars">
        {[1, 2, 3].map((level) => (
          <span
            key={level}
            className={`auth-password-strength-bar ${
              strength.score >= level ? `auth-password-strength-bar--${strength.className}` : ''
            }`}
          />
        ))}
      </div>
      <span className={`auth-password-strength-label auth-password-strength-label--${strength.className}`}>
        Senha {strength.label.toLowerCase()}
      </span>
    </div>
  );
};

export default PasswordStrength;
